export default __webpack_public_path__ + "images/19ca3fa15af3304a0a94549c8368cf05.jpg";